import React, { PureComponent, Fragment } from 'react';
import isSnap from 'utils/isSnap';
import get from 'utils/get';
import Meta from 'components/Meta';

const defaultTitle = 'The Nobel Prize | Women who changed science';
const defaultDescription =
  'Explore the lives and achievements of female Nobel Laureates who broke new ground in physics, chemistry and medicine.';
const defaultImageUrl =
  'https://winstemfrontsa02.z16.web.core.windows.net/assets/share.jpg';

export default (WrappedComponent, path) => {
  // eslint-disable-next-line
  return class extends PureComponent {
    renderMeta = () => {
      const holder = this.props[path];
      if (!holder) return null;

      return (
        <Meta
          title={get(holder, 'metaTitle', defaultTitle)}
          description={get(holder, 'metaDescription', defaultDescription)}
          image={get(holder, 'metaImage.url', defaultImageUrl)}
        />
      );
    };

    render() {
      // If we're rendering from react-snap, dont render the body
      if (isSnap()) return this.renderMeta();

      // As u were
      return (
        <Fragment>
          {this.renderMeta()}
          <WrappedComponent {...this.props} />
        </Fragment>
      );
    }
  };
};
